@if (data.template) {
  <ng-template [ngTemplateOutlet]="data.template" />
}
@if (data.text) {
  {{ data.text }}
}
